import * as Types from './actionTypes';


export function getUserCheckins(params) {
  return {type: Types.USER_CHECKINS_LIST_GET, params};
}

export function getUserCheckinsSuccess(response) {
  return {type: Types.USER_CHECKINS_LIST_GET_SUCCESS, payload: response};
}

export function getUserCheckinsFailure(error) {
  return {type: Types.USER_CHECKINS_LIST_GET_FAILURE, error};
}



// WEBPACK FOOTER //
// ./shared/checkins/redux/actions.js